import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    HostListener,
    ChangeDetectorRef, AfterViewChecked
} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';

import 'rxjs/add/operator/filter';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {IconsService, IIconItem} from "../services/icons.service";
import {StateService} from "../services/state.service";
import {SEOService} from "../services/seo.service";
import {SettingsService} from "../services/settings.service";


@Component({
    selector: 'start',
    templateUrl: './start.component.html',
    styleUrls: [
        './start.component.less',
        './start.icons.less',
        './privacy.navigation.less',
        './more.menu.less'
    ],
    animations: [
        trigger("bubble", [
            state('init', style({
                opacity: '0',
            })),
            state('lens', style({
                opacity: '1',
            })),
            state('bubble', style({
                opacity: '1',
            })),
            state('dock', style({
                opacity: '1',
            })),
            transition('init => lens', [
                animate('2s ease-out')
            ]),
            transition('init => bubble', [
                animate('2s ease-out')
            ]),
            transition('lens => dock', [
                animate('1s ease-out')
            ]),
            transition('bubble => dock', [
                animate('2s ease-out')
            ])

        ])]

})
export class StartComponent implements OnInit, OnDestroy, AfterViewChecked {

    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        private SEOService: SEOService,
        private icons: IconsService,
        private state: StateService,
        private cdRef:ChangeDetectorRef,
        private settingsService: SettingsService
    ) {


        this.setDockModel();
        this.setIconList();
        this.setSocialIconList();

        this.skin = this.settingsService.getSkin();
        if(this.skin === undefined){
            this.getSkin();
        }

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.icons.setIcons();
        this.setIconList();
        this.iconsSM('init');
    }

    @Input() animation: boolean;

    ngOnInit() {
        // set meta tags
        const { meta } = this.activatedRoute.snapshot.data;
        this.SEOService.updateTitle(meta.title);
        this.SEOService.updateDescription(meta.description);
    }

    ngAfterViewChecked() : void {
        this.iconsSM('init');
        this.cdRef.detectChanges();
    }

    ngOnDestroy() {
        clearTimeout(this.timer);
        clearInterval(this.rotateTimer);
    }

    public skin: string;

    public dockMode = 'home';
    public mainSize: 'full' | 'medium' | 'small2' | 'xs2';
    public dockSize: 'full' | 'medium' | 'small2' | 'xs2' | 'xxs2';
    public dockShow: 'dock-show' | 'dock-hide';

    public collapse: boolean;
    public dockModel: any = {};
    public rotateTimer;

    /* SKIN CONTROLLER */
    getSkin() {
        this.settingsService.getSettings().subscribe(
            (res: any[]) => {
                console.log('SETTINGS IS:', res)
                this.skin = res['skin'] || '';
            },
            (err) => {

            }
        );
    }

    /***************************************************************************************************
     *
     *    ICONS CONTROLLER
     *
     *************************************************************************************************/

    public iconList: IIconItem[];

    setIconList(){
        this.iconList = <any>[];
        this.icons.getIcons().map(icon => {
            this.iconList.push(icon);
        });
    }


    setDockModel() {
        this.dockModel = {};
        this.dockModel.width = window.innerWidth;
        this.dockModel.height = window.innerHeight;
        this.dockModel.centerX = window.innerWidth / 2;
        this.dockModel.centerY = window.innerHeight / 2;
        this.dockModel.radius = Math.min(this.dockModel.centerX, this.dockModel.centerY) / (3 / 1.8);
    }

    initIconParams() {
        this.bubbleCount = 0;
        this.iconList.map(p => {
            p.state = 'init';
            p.type = 'tool';

            if (this.mainSize == 'full' || this.mainSize == 'medium') {
                p.mode = (p.class == 'voice' || p.class == 'messaging') ? 'lens' : 'bubble';
            }
            else {
                p.mode = 'bubble';
            }

            if (p.mode == 'bubble' && !(p.class == 'home')) this.bubbleCount++;


        })

    }


    analyzeSize() {
        this.mainSize = (window.innerWidth >= 1440) ? 'full' : (window.innerWidth >= 1024) ? 'medium' : (window.innerWidth >= 768) ? 'small2' : 'xs2';
        this.mainSize = ((this.mainSize == 'full' || this.mainSize == 'medium') && (window.innerHeight < 700)) ? 'small2' : this.mainSize;

        this.dockSize = (window.innerWidth >= 1440) ? 'full' : (window.innerWidth >= 1024) ? 'medium' : (window.innerWidth >= 768) ? 'small2' : (window.innerWidth >= 540) ? 'xs2' : 'xxs2';
        this.dockSize = ((this.dockSize == 'full' || this.dockSize == 'medium') && (window.innerHeight < 700)) ? 'small2' : this.dockSize;

    }

    /***************************************************************************************************
     *
     *    ICONS State Machine
     *
     *************************************************************************************************/

    public currentState;
    public nextState;
    public animationOpacity = 0;
    public iconsWasRotated = false;

    iconsSM(state) {
        switch (state) {
            case 'init':
                this.animationOpacity = 0;
                this.setDockModel();
                this.analyzeSize();
                this.initIconParams();

                this.setIconPosition();
                this.dockBottom = '0';
                if (this.mainSize == 'full') {
                    this.nextState = (this.iconsWasRotated) ? 'bubble' : 'rotate';
                } else {
                    this.nextState = 'bubble';
                }


                this.currentState = state;
                this.iconsSM(this.nextState);
                break;

            case 'rotate': // animation
                this.iconsWasRotated = true;
                this.startRotation();
                this.currentState = state;
                this.nextState = 'bubble';
                break;

            case 'bubble': // state
                this.currentState = state;
                break;

            case 'burst': // animation
                break;

            case 'tools':
                break;

            default:
                break;
        }

    }


    public socialList: IIconItem[];

    setSocialIconList() {
        this.socialList = <any>[];
        this.icons.getSocialIcons().map(icon => {
            icon.x = 0;
            icon.mode = 'social';
            this.socialList.push(icon); // sorting by bubblePosition

        });
    }

    //
    // ROTATION CONTROLLER
    //
    public timer;
    public bubbleCount = 8;
    public timeStep = 40;
    public timeInterval = 1000;
    public startPhase = - 2 * Math.PI / this.bubbleCount * 10;//-this.timeInterval / this.timeStep * 0.5;
    public stopPhase =  2 * Math.PI / this.bubbleCount*3;
    public phase = this.startPhase;


    setIconPosition() {
        this.bubbleCount = 8;
        if (this.bubbleCount > 0) {
            let alpha = 0;
            this.iconList.forEach(m => {
                alpha = 2 * Math.PI / this.bubbleCount * m.bubblePosition;
                if (m.mode == 'bubble' && !(m.class == 'home' || m.class == 'social')) {
                    m.x = this.dockModel.centerX - 50 - Math.cos(alpha + this.phase / Math.PI / 2) * this.dockModel.radius;
                    m.y = this.dockModel.centerY - 70 - Math.sin(alpha + this.phase / Math.PI / 2) * this.dockModel.radius;
                    // alpha += 2 * Math.PI / this.bubbleCount;
                }
            })
        }
    }


    public rotation = false;

    rotationIcon() {

        if(!this.rotation) return;
        this.setIconPosition();
        this.animationOpacity += 100 / 1000;
        if(this.phase < this.stopPhase){
            this.phase += 2 * Math.PI / this.bubbleCount ;
        }else{
            this.stopRotation();
        }
        this.timer = window.setTimeout(this.rotationIcon.bind(this), this.timeStep);
    }

    startRotation() {
        this.rotation = true;
        this.phase = this.startPhase;
        if (this.timer) clearTimeout(this.timer);
        this.timer = window.setTimeout(this.rotationIcon.bind(this), this.timeStep);
    }

    stopRotation() {
        this.rotation = false;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.iconsSM(this.nextState);
    }

    // public iconsState: string;
    iconsDownToDock() {

    }

    public dockBottom = '0';

    onShowDock(state) {
        // console.log(state)
        this.dockShow = state || (this.dockShow == 'dock-show') ? 'dock-hide' : 'dock-show';
        switch (this.dockSize) {
            case 'full':
                this.dockBottom = '0';
                break;

            case 'medium':
                this.dockBottom = '0';
                break;

            case 'small2':
                if (this.dockMode == 'home') break;

                this.dockBottom = (this.dockShow == 'dock-show') ? '0' : '-100vh';
                break;

            case 'xs2':
                if (this.dockMode == 'home') break;

                this.dockBottom = (this.dockShow == 'dock-show') ? '0' : '-100vh';
                break;

            case 'xxs2':
                if (this.dockMode == 'home') break;

                this.dockBottom = (this.dockShow == 'dock-show') ? '0' : '-100vh';
                break;

            default:

                this.dockBottom = '0';
                break;

        }
    }

    onLogin(){

    }

    showEng(item){

    }


    onPush(ref, icon) {
        // console.log(ref)
        ref.target.className = ref.target.className + " push";
    }

    onMouseUp(ref, icon) {
        // ref.target.className = ((icon.mode == 'social') ? 'social-icons-item ' : 'icon-item ') + icon.class;
    }


    // MORE PANEL
    showMorePanel: boolean = false;
    onClickMoreBtn(){
        this.showMorePanel = !this.showMorePanel;
    }

    onCloseMorePanel(){
        this.showMorePanel = false;
    }




}


